import {h, Component} from 'preact';
import constants from '../constants';
import {connect} from 'react-redux';
import * as actions from '../actions';
import reduce from '../reducers';

export default @connect(reduce, actions)
class AsideElements extends Component {
    constructor() {
        super()
        this.state = {
        }
    }

    render (props, state) {
        return (
            <div id="app-aside-frames" class="aside-text">
                <div class="scroller no-top">
                    <div class="to-root">
                        <a onClick={ () => props.goToRoot() }>
                            All graphics
                        </a>
                        <span class="path">&gt;&nbsp; Photo Area</span>
                    </div>
                    <div class="components frames">
                        <div class="component template frame">
                            <div data-component="frame" data-type="frame" data-ratio="1" class="frame" data-opacity="1"
                                 style="display: flex; width: 80px; height: 80px;">
                                <div class="img"
                                     style={"width: 100%; height: 100%; background: url('" + constants.appPrefix + "/image/img-plc.png'); background-size: cover; background-position: center;"}
                                     data-original-bg-img={constants.appPrefix + "/image/img-plc.png"}></div>
                            </div>
                        </div>

                        <div class="component template frame">
                            <div data-component="frame" data-type="frame" data-ratio="1" class="frame" data-opacity="1"
                                 style="border-radius: 100%; display: flex; width: 80px; height: 80px;">
                                <div class="img"
                                     style={"border-radius: 100%; width: 100%; height: 100%; background: url('" + constants.appPrefix + "/image/img-plc.png'); background-size: cover; background-position: center;"}
                                     data-original-bg-img={constants.appPrefix + "/image/img-plc.png"}></div>
                            </div>
                        </div>

                        <div class="component template frame">
                            <div data-component="frame" data-type="frame" data-ratio=".75" class="frame" data-opacity="1"
                                 style="display: flex; width: 60px; height: 80px;">
                                <div class="img"
                                     style={"width: 100%; height: 100%; background: url('" + constants.appPrefix + "/image/img-plc.png'); background-size: cover; background-position: center;" }
                                     data-original-bg-img={constants.appPrefix + "/image/img-plc.png"}></div>
                                <div class="meta meta-ratio">3:4</div>
                            </div>
                        </div>

                        <div class="component template frame">
                            <div data-component="frame" data-type="frame" data-ratio="1.33" class="frame" data-opacity="1"
                                 style="display: flex; width: 80px; height: 60px;">
                                <div class="img"
                                     style={"width: 100%; height: 100%; background: url('" + constants.appPrefix + "/image/img-plc.png');background-size: cover; background-position: center;" }
                                     data-original-bg-img={constants.appPrefix + "/image/img-plc.png"}></div>
                                <div class="meta meta-ratio">4:3</div>
                            </div>
                        </div>

                        <div class="component template frame">
                            <div data-component="frame" data-type="frame" data-ratio="1.77" class="frame" data-opacity="1"
                                 style="display: flex; width: 80px; height: 45px;">
                                <div class="img"
                                     style={"width: 100%; height: 100%; background: url('" + constants.appPrefix + "/image/img-plc.png'); background-size: cover; background-position: center;" }
                                     data-original-bg-img={constants.appPrefix + "/image/img-plc.png"}></div>
                                <div class="meta meta-ratio">16:9</div>
                            </div>
                        </div>

                        <div class="component template frame">
                            <div data-component="frame" data-type="frame" data-ratio="0.56" class="frame" data-opacity="1"
                                 style="display: flex; width: 45px; height: 80px;">
                                <div class="img"
                                     style={"width: 100%; height: 100%; background: url('" + constants.appPrefix + "/image/img-plc.png'); background-size: cover; background-position: center;" }
                                     data-original-bg-img={constants.appPrefix + "/image/img-plc.png"}></div>
                                <div class="meta meta-ratio">9:16</div>
                            </div>
                        </div>

                        <div class="component template frame">
                            <div data-component="frame" data-type="frame" data-ratio="full-page" class="frame" data-opacity="1"
                                 style="display: flex; width: 80px; height: 80px;">
                                <div class="img"
                                     style={"width: 100%; height: 100%; background: url('" + constants.appPrefix + "/image/img-plc.png');background-size: cover; background-position: center;" }
                                     data-original-bg-img={constants.appPrefix + "/image/img-plc.png"}></div>
                                <div class="meta meta-ratio">Full Page</div>
                            </div>
                        </div>

                        
                        {(props.isDesigner || props.isAdmin) && 
                        <div class="component template qr">
                            <div class="qr" data-component="qr-code" data-ratio="1">
                                <img src={constants.appPrefix + '/image/qr-plc.jpg'} class="img"></img>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        )
    }
}